import Activity from "../../Namespaces/Activity/Activity";
import Discussions from "../../Namespaces/Discussions/Discussions";
import Challenges from "../../Namespaces/Challenges/Challenges";
import Football from "../../Namespaces/Football/Football";
import Loyalty from "../../Namespaces/Loyalty/Loyalty";
import MatchQuiz from "../../Namespaces/MatchQuiz/MatchQuiz";
import MiniGames from "../../Namespaces/MiniGames/MiniGames";
import Predictor from "../../Namespaces/Predictor/Predictor";
import PrivateLeagues from "../../Namespaces/PrivateLeagues/PrivateLeagues";
import Profile from "../../Namespaces/Profile/Profile";
import TopX from "../../Namespaces/TopX/TopX";
import Progress from "../../Namespaces/Progress/Progress";
import Voting from "../../Namespaces/Voting/Voting";
import Fantasy from "../../Namespaces/Fantasy/Fantasy";
import SDKVersionModel from "../../Version/Models/SDKVersionModel";
import Helpers from "../../Namespaces/Helpers/Helpers";
import IdMapping from "../../Namespaces/IdMapping/IdMapping";
import BracketGame from "../../Namespaces/BracketGame/BracketGame";
import Lists from "../../Namespaces/Lists/Lists";
import StandingGame from "../../Namespaces/StandingGame/StandingGame";
import Odds from "../../Namespaces/Odds/Odds";
import EventGame from "../../Namespaces/EventGame/EventGame";

export default class FansUnitedSDKModel {
  public profile: Profile = null;
  public football: Football = null;
  public predictor: Predictor = null;
  public loyalty: Loyalty = null;
  public topX: TopX = null;
  public matchQuiz: MatchQuiz = null;
  public activity: Activity = null;
  public miniGames: MiniGames = null;
  public discussions: Discussions = null;
  public privateLeagues: PrivateLeagues = null;
  public challenges: Challenges = null;
  public progress: Progress = null;
  public voting: Voting = null;
  public fantasy: Fantasy = null;
  public helpers: Helpers = null;
  public idMapping: IdMapping = null;
  public bracketGame: BracketGame = null;
  public lists: Lists = null;
  public standingGame: StandingGame = null;
  public eventGame: EventGame = null;
  public odds: Odds = null;
  public getVersion: () => SDKVersionModel = null;
}
